import { createContext, useContext } from 'react'

export const AdminLayoutContext = createContext(false)

export const useIsAdminLayout = () => useContext(AdminLayoutContext)

type ContentHeaderActions = {
  slot: HTMLElement | null
  attach: (node: HTMLElement | null) => void
}

export const ContentHeaderActionsContext = createContext<ContentHeaderActions | null>(null)

export const useContentHeaderActions = () => useContext(ContentHeaderActionsContext)
